<div class="box">
  <div class="box-row header mb-2">
    <app-header-bar
      [backRoute]="'/admin-jobs'"
      [title]="job?.name || 'job.admin.title'"
      [autoTranslateTitle]="job === undefined"
    ></app-header-bar>
  </div>
  <app-loading-indicator [loading]="isLoading"></app-loading-indicator>
  @if (job) {
    <div class="card">
      <div class="row">
        <div class="col-4">
          <h6 class="fw-bold">{{ 'job.status' | translate }}</h6>
          <p class="fs-5" [innerHTML]="job.status | toStatusBadge"></p>
        </div>
        <div class="col-4">
          <h6 class="fw-bold">{{ 'job.lastUpdatedAt' | translate }}</h6>
          <p class="fs-5" [innerHTML]="job.lastUpdatedAt | timeAgo"></p>
        </div>
        <div class="col-4">
          <h6 class="fw-bold">{{ 'job.createdAt' | translate }}</h6>
          <p class="fs-5">{{ job.createdAt | dateTime }}</p>
        </div>
        <div class="col-4">
          <h6 class="fw-bold">{{ 'organization' | translate }}</h6>
          <p class="fs-5">{{ job.organization?.name || '-' }}</p>
        </div>
        @if (job.lastWorker) {
          <div class="col-4">
            <h6 class="fw-bold">{{ 'WORKER' | translate }}</h6>
            <p class="fs-5">
              {{ job.lastWorker.given_name + ' ' + job.lastWorker.family_name }}
            </p>
          </div>
        }
        @if (job.lastHandheld) {
          <h5 class="fw-bold mt-3">{{ 'mdm.singular' | translate }}</h5>
          <div class="col-4">
            <h6 class="fw-bold">{{ 'mdm.name' | translate }}</h6>
            <p class="fs-5">{{ job.lastHandheld.name }}</p>
          </div>
          <div class="col-4">
            <h6 class="fw-bold">{{ 'mdm.os' | translate }}</h6>
            <p class="fs-5">{{ job.lastHandheld.os }}</p>
          </div>
          <div class="col-4">
            <h6 class="fw-bold">{{ 'mdm.appVersion' | translate }}</h6>
            <p class="fs-5">{{ job.lastHandheld.appVersion }}</p>
          </div>
        }
      </div>
      @if (!job.result.length) {
        <table class="mt-4">
          <thead>
            <tr>
              @for (key of getArticleKeys(job.data[0]); track key) {
                @if (key !== 'job') {
                  <th scope="col">{{ getHeader(key) | async | titlecase }}</th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (result of job.data; track result) {
              <tr>
                @for (key of getArticleKeys(result); track key) {
                  @if (key !== 'job') {
                    <td>{{ result[key] }}</td>
                  }
                }
              </tr>
            }
          </tbody>
        </table>
      }
      @if (job.result.length > 0) {
        <table class="mt-4">
          <thead>
            <tr>
              @for (key of getArticleKeys(job.result[0]); track key) {
                @if (key !== 'check') {
                  <th scope="col">{{ getHeader(key) | async | titlecase }}</th>
                }
              }
              <th scope="col">{{ 'job.check' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (result of job.result; track result) {
              <tr>
                @for (key of getArticleKeys(result); track key) {
                  @if (key !== 'check') {
                    <td>{{ result[key] }}</td>
                  }
                }
                <td>
                  @if (result['check']) {
                    <span>{{ asString(result['check']) | dateTime }}</span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  }
  <app-error [error]="error"></app-error>
</div>
